module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"noInformation":"Keine Angabe"},"en":{"noInformation":"No information"}}')
  delete Component.options._Ctor
}
